import { useState } from "react";

const safeParseToken = (tokenString) => {
  try {
    if (!tokenString) {
      return null;
    }

    return JSON.parse(tokenString);
  } catch (error) {
    return null;
  }
};

export default function useToken() {
  const getToken = () => {
    const tokenString = localStorage.getItem("token");
    const userToken = safeParseToken(tokenString);
    return userToken;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    localStorage.setItem("token", JSON.stringify(userToken));
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token,
  };
}
